import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Flex, Heading, Text } from '@stepstone-genesis/components';
import { Trans, useTranslation } from '@stepstone-platform/i18n';
export const ImportProfileHeader = ({ givenName }) => {
    const { t } = useTranslation();
    return (_jsxs(Flex, { flxDirection: 'column', gap: 'spaceS', children: [_jsx(Heading, { as: "h2", variant: 'heading2', children: _jsx(Trans, { i18nKey: 'loginregistration.linkedIn.importProfile.header', values: { givenName } }) }), _jsx(Text, { color: 'colorGreyDark', variant: "bodyLarge", children: t('loginregistration.linkedIn.importProfile.underHeader') })] }));
};
//# sourceMappingURL=ImportProfileHeader.js.map